<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{header}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <div class="flex flex-col lg:flex-row items-center justify-between gap-x-6">
              <div ref="nombreMetadatoUpdate" class="w-full mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.metadatos.metadato_name') }}</label>
                <el-form-item prop="nombreMetadatoUpdate">
                  <el-input
                    class="w-full"
                    v-model="form.nombreMetadatoUpdate"
                    :type="typeInput"
                    :maxlength='100'
                    @change="onChangeCampo"
                  />
                </el-form-item>
              </div>
            <div ref="tipoMetadato" class="w-full mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.type') }}</label>
              <el-form-item prop="tipoMetadato">
                <el-select
                  class="w-full"
                  v-model="tipoMetadato"
                  disabled>
                  <el-option
                    v-for="(item, index) in tiposMetadatosCreacion"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          </el-form>
          <div>
             <el-table
              ref="metadatavalues"
              :data="valoresMetadato"
              style="width: 100%"
              max-height="200"
              :show-header="false">
              <el-table-column
                prop="Nombre"
                label="Nombre"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="actions"
                width="80"
                align="center"
                label="-">
                <template slot-scope="scope">
                <div class="flex flex-row">
                  <!-- <base-button-icon @click="editMetadatoAdicional(scope)" name="editpencil" mode="core" size="xs" /> -->
                  <base-button-icon @click="deleteValor(scope.row)" name="trash" mode="core" size="xs" />
                </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="w-full float-right">
              <base-button-responsive
                mode="primary"
                :text="$t('configurations.add_value')"
                @click="newValorToggleDialog()"
                icon="plus"
                class="mt-5 float-right"
              />
            </div>
          </div>
      </div>
      <input-text-dialog 
        :dialogOpen="showModalValor" 
        @toggleDialog="newValorToggleDialog" 
        @applyDialog="applyNewValorDialog"
        header="Añadir nuevo valor" 
        headerValue="Nombre del nuevo valor" 
        :maxLength="250"
        />
    </template>
    <template slot="footer">
      <base-button @click="toggleDialog" class="w-full" mode="secondary-phantom-blue" :text="$t('app.back')" />
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.save')" @click="apply('ruleForm')" />
    </template>
  </base-dialog-button>
</template>

<script>
import { i18n } from '@/i18n'
import BaseDialogButton from './base/BaseDialogButton.vue'
import InputTextDialog from '@/components/InputTextDialog.vue'
import { getValoresMetadatoCliente } from '@/services/clients/getValoresMetadatoCliente' 
import { agregarValorMetadatoCliente } from '@/services/clients/agregarValorMetadatoCliente' 
import { eliminarValorMetadatoCliente } from '@/services/clients/eliminarValorMetadatoCliente' 

export default
{
  name: 'input-modify-metadata-dialog',
  components: {
    BaseDialogButton,
    InputTextDialog,
  },
  props: {
    header: {
      type: String,
      default: 'Importante'
    },
    dialogOpen: {
      type: Boolean,
      default: false
    },
    campoMetadato: {
      type: String,
      default: '',
    },
    tipoMetadato: {
      type: Number,
      default: 0,
    },
    typeInput: {
      type: String,
      default: 'text',
    },
    idCliente: {
      type: Number,
      default: -1,
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      showModalValor: false,
      valoresMetadato: [],
      form: {
        nombreMetadatoUpdate: '',
      },
      rules: {
        nombreMetadatoUpdate: [
          {
            required: true,
            message: i18n.t('validation.complete'),
            trigger: 'blur'
          }
        ],
      }
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      if (value) {
        this.downloadListvalores()
      }
    }
  },
  mounted: async function () {
  },
  computed: {
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    role: function () {
      return this.$store.getters['auth/role'].toLowerCase()
    },
    tiposMetadatosCreacion: function () {
      return this.$store.getters['config/TIPOS_METADATOS_CREACION']
    },
  },
  methods: {
    onChangeCampo (value) {
      this.form.nombreMetadatoUpdate = value.toLocaleUpperCase().replaceAll(' ', '_')
    },
    newValorToggleDialog () {
      this.showModalValor = !this.showModalValor
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    applyNewValorDialog: async function (nombre) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          Campo: this.campoMetadato, 
          idCliente: this.idCliente,
          Valor: nombre,
        }
        const response = await agregarValorMetadatoCliente(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.newValorToggleDialog()
          this.downloadListvalores()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    deleteValor: async function (row) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          Campo: this.campoMetadato, 
          idCliente: this.idCliente,
          Valor: row.Nombre,
        }
        const response = await eliminarValorMetadatoCliente(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.downloadListvalores()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadListvalores: async function () {
      this.form.nombreMetadatoUpdate = this.campoMetadato
      this.valoresMetadato = []
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          Campo: this.campoMetadato, 
          idCliente: this.idCliente,
        }
        const response = await getValoresMetadatoCliente(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.valoresMetadato = response.Respuesta.map(x => ({ Nombre: x }))
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    apply: async function (ruleForm) {
      this.$refs[ruleForm].validate(async valid => {
        if (valid) {
          this.isOpen = !this.isOpen
          const payload = {
            Campo: this.campoMetadato,
            NombreNuevo: this.form.nombreMetadatoUpdate
          }
          this.$emit('applyDialog', payload)
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
      })
    },
  }
}
</script>
